import React, { useState } from 'react';

import CityDistanceServices from 'services/CityDistanceServices';
import useToggleDrawer from 'hooks/useToggleDrawer';
import PageTitle from 'components/Typography/PageTitle';
import MainDrawer from 'components/drawer/MainDrawer';
import CityDistanceDrawer from 'components/drawer/CityDistanceDrawer';
import { useContext } from 'react';
import { SidebarContext } from 'context/SidebarContext';
import NotFound from 'components/table/NotFound'; // Import NotFound component
import DataWrapper from './DataWrapper';
import DeleteModal from 'components/modal/DeleteModal';
import useAsync from 'hooks/useAsync';
import { FiRefreshCcw } from 'react-icons/fi';
import CityDistanceTable from 'components/city/cityDistanceTable';
import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import { FiPlus } from 'react-icons/fi';
import sidebar from 'routes/sidebar';
import ExportDataXlsx from 'components/common/ExportDataXlsx';

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color:grey;
  padding: 9px 10px;
  margin: unset;
}`;

const City = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
	const [searchText, setSearchText] = useState('');
	const { data, loading, error } = useAsync(() =>
		CityDistanceServices.getAllCity()
	);
	const [status] = useState('');
	const isDataArray = Array.isArray(data?.data); // Check if data is an array
	const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'city distance' && perm.view === 1
		  );

	const hideDelete = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'city distance' && perm.delete === 1
		  );

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'city distance' && perm.edit === 1
		  );

	const hideAdd = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'city distance' && perm.add === 1
		  );

	const hideExport = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'city distance' && perm.export === 1
		  );

	const { title, serviceId, handleModalOpen, handleUpdate, isSubmitting } =
		useToggleDrawer();

	// Contains the column headers and table data in the required format for CSV

	const csvData = [
		['S.No','From City', 'To City', 'Duration', 'Distance'],
		...safeData.map(({ from_city_name, to_city_name, duration, distance }, index) => [
			index + 1, 
			from_city_name,
			to_city_name,
			duration,
			// distance,
			distance+" km",
		]),
	];

	const filteredData = safeData.filter(
		(item) =>
			(item.from_city_name !== null &&
				item.from_city_name.toLowerCase().includes(searchText.toLowerCase())) ||
			(item.to_city_name !== null &&
				item.to_city_name.toLowerCase().includes(searchText.toLowerCase())) ||
			(item.duration !== null &&
				item.duration.toLowerCase().includes(searchText.toLowerCase()))
	);

	const handleRefresh = () => {
		setIsUpdate(true);
	};

	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />

					<style>{style}</style>
					<PageTitle sidebar={sidebar().sidebar} />

					<MainDrawer>
						<CityDistanceDrawer id={serviceId} />
					</MainDrawer>

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<form className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										value={searchText}
										onChange={(e) => setSearchText(e.target.value)}
										placeholder="Quick Search"
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add City Distance
									</Button>
								)}

								{hideExport && (
									<div className="items-center">
										<ExportDataXlsx
											title="City"
											exportDataXlsx={csvData}
											fileNames="City Distance List"
										/>
									</div>
								)}

								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</form>
						</CardBody>
					</Card>

					{/* <div className="data-table-container"> */}
						<DataWrapper loading={loading} error={error} status={status}>
							{filteredData.length > 0 ? (
								<TableContainer
									className="mb-8"
									style={{
										maxHeight: '65vh',
										overflowY: 'scroll',
										scrollbarWidth: 'thin',
									}}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize sticky top-0 z-10">
											<tr>
												<TableCell className="text-center">Sl.No.</TableCell>
												<TableCell className="text-center">From City</TableCell>
												<TableCell className="text-center">To City</TableCell>
												<TableCell className="text-center">KM</TableCell>
												<TableCell className="text-center">Duration</TableCell>
											{hideEdit&&(
											<TableCell className="text-center">Actions</TableCell>
											)}	
											</tr>
										</TableHeader>

										<CityDistanceTable
											id={data.id_city}
											title={data.name}
											citydata={filteredData}
											isSubmitting={isSubmitting}
											handleUpdate={handleUpdate}
											handleModalOpen={handleModalOpen}
											// hideDelete={hideDelete}
											hideEdit={hideEdit}
										/>
									</Table>
								</TableContainer>
							) : (
								// Show NotFound if there is no data
								<NotFound title="There are no City Distances." />
							)}
						</DataWrapper>
					{/* </div> */}
				</>
			)}
		</>
	);
};

export default City;
